import React, {Component} from "react";
import {
    Route,
    NavLink,
    HashRouter
} from "react-router-dom";

import RL from "./BlogComponents/RL";
import BigData from "./BlogComponents/BigData";
import ML from "./BlogComponents/ML";
import WebTopics from "./BlogComponents/WebTopics";
import Featured from "./BlogComponents/Featured";
import DL from "./BlogComponents/DL";
import Prog from "./BlogComponents/Prog";
import News from "./BlogComponents/News";
import Research from "./BlogComponents/Research";

class Blogs extends Component {
    render() {

        return (
            <div>
                <div>
                    <h1 id="home-h1">Blogs</h1>
                </div>
                <div className="contact-div">
                    <h2>
                        I haven't tried writing blogs and articles myself but 
                        I have compiled a list of blogs, articles and papers
                        by expert as well as novice authors which helped me on my
                        path to learn new things.
                    </h2>    
                    <h2>Click on the topic to see topic related articles and blogs.</h2>
                    <h5>*Currently not updated*</h5>
                </div>    
                <div className="content-sec">
                    <h2>#Contents</h2>
                    <p></p>
                    <HashRouter>
                        <h3 style={{display:'flex',flexDirection:'row',alignItems:'stretch',justifyContent:'space-between'}}><NavLink to="/blogs">Featured</NavLink></h3> 
                        <div className="flex-container-contents">
                            
                            <h3 style={{display:'flex',flexDirection:'row',alignItems:'stretch',justifyContent:'space-between'}}><NavLink to="/blogs/ML">Machine Learning & DS</NavLink></h3>
                            <h3 style={{display:'flex',flexDirection:'row',alignItems:'stretch',justifyContent:'space-between'}}><NavLink to="/blogs/RL">Reinforcement Learning</NavLink></h3>
                            <h3 style={{display:'flex',flexDirection:'row',alignItems:'stretch',justifyContent:'space-between'}}><NavLink to="/blogs/DL">Deep Learning</NavLink></h3>
                            <h3 style={{display:'flex',flexDirection:'row',alignItems:'stretch',justifyContent:'space-between'}}><NavLink to="/blogs/WebTopics">Web</NavLink></h3>
                            <h3 style={{display:'flex',flexDirection:'row',alignItems:'stretch',justifyContent:'space-between'}}><NavLink to="/blogs/Research">Research</NavLink></h3>
                            <h3 style={{display:'flex',flexDirection:'row',alignItems:'stretch',justifyContent:'space-between'}}><NavLink to="/blogs/News">News</NavLink></h3>
                            <h3 style={{display:'flex',flexDirection:'row',alignItems:'stretch',justifyContent:'space-between'}}><NavLink to="/blogs/Prog">Programming</NavLink></h3>
                            <h3 style={{display:'flex',flexDirection:'row',alignItems:'stretch',justifyContent:'space-between'}}><NavLink to="/blogs/BigData">Big Data</NavLink></h3>
                        </div>
                        <div className="blog-content">
                            <Route exact path="/blogs" component={Featured}/>
                            <Route path="/blogs/RL" component={RL}/>
                            <Route path="/blogs/ML" component={ML}/>
                            <Route path="/blogs/DL" component={DL}/>
                            <Route path="/blogs/Research" component={Research}/>
                            <Route path="/blogs/Prog" component={Prog}/>
                            <Route path="/blogs/News" component={News}/>
                            <Route path="/blogs/BigData" component={BigData}/>
                            <Route path="/blogs/WebTopics" component={WebTopics}/>
                        </div>
                    </HashRouter>


                </div>    
            </div>     
        );
    }
}

export default Blogs;